// test1144
(1144 && 0);
